import { Component, Input } from '@angular/core';
import { faTrash, IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { Store } from '@ngxs/store';
import { RemoveBrickFromWall } from 'src/app/store/dashboard/brick-wall/brick-instances/brick-instances.actions';

@Component({
   selector: 'samweb-brick-control-overlay',
   templateUrl: './brick-control-overlay.component.html',
   styleUrls: ['./brick-control-overlay.component.scss'],
})
export class BrickControlOverlayComponent {
   @Input()
   public brickInstanceId: string;

   public removeBrickIcon: IconDefinition = faTrash;

   constructor(private store: Store) {}

   public removeBrick(): void {
      this.store.dispatch(new RemoveBrickFromWall(this.brickInstanceId));
   }
}
